(function () {
  var toastHideTimeout = null;

  function serializeForm(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }

  function getCartRoutes() {
    var el = document.querySelector('[data-cart-routes]');
    return el ? JSON.parse(el.innerHTML) : null;
  }

  function getToastStrings() {
    var el = document.getElementById('product-card-toast-strings');
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function updateHeaderCartCount(count) {
    var countEls = document.querySelectorAll('[data-cart-count]');
    var bubbleEls = document.querySelectorAll('[data-cart-count-bubble]');
    countEls.forEach(function (el) {
      el.textContent = count;
    });
    bubbleEls.forEach(function (el) {
      if (count > 0) {
        el.classList.remove('hide');
      } else {
        el.classList.add('hide');
      }
    });
  }

  function handleSubmit(evt) {
    var form = evt.target;
    if (!form || form.getAttribute('data-product-card-add') === null) return;

    // Skip if it's inside the PDP product form
    if (form.closest('.product-form')) {
      return; // Let Slate handle it
    }

    console.log('[atc] Custom handler firing');
    var routes = getCartRoutes();
    if (!routes || !routes.cartAddUrl) return;

    evt.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    fetch(routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: serializeForm(form)
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          throw new Error(data.description || 'Cart error');
        }
        return fetch((routes.cartUrl || '/cart') + '.js', { credentials: 'same-origin' });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateHeaderCartCount(cart.item_count || 0);
        // Trigger cart refresh and open drawer
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function () {
        form.removeAttribute('data-product-card-add');
        form.submit();
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          if (originalText && originalText.trim()) {
            submitBtn.textContent = originalText;
          }
        }
      });
  }

  document.addEventListener('submit', handleSubmit);
})();